import React, { useEffect } from 'react';
import { formatPrice } from '../../../data/modules';
import { useModuleCatalog } from '../../../data/useModuleCatalog';

const FAQSection = () => {
  const { purchasableModules, vatIncluded } = useModuleCatalog();

  // ⚠️ Fiyat cümlesi ELLE YAZILMIYOR. Yazıldığı sürece panelden yapılan zam
  // fiyat bölümüne yansıyıp SSS'de eski değeriyle kalıyordu — aynı sayfada
  // iki farklı fiyat, hangisinin doğru olduğunu söyleyecek hiçbir şey yok.
  const paidModules = purchasableModules.filter((module) => module.price.monthly > 0);
  const priceSentence = paidModules
    .slice()
    .sort((a, b) => a.price.monthly - b.price.monthly)
    .map((module) => `${module.name} ${formatPrice(module.price.monthly)}`)
    .join(', ');

  const trialSentence = (() => {
    const byTrial = new Map();
    for (const module of paidModules) {
      if (!module.trialDays) continue;
      byTrial.set(module.trialDays, [...(byTrial.get(module.trialDays) || []), module.name]);
    }
    return [...byTrial.entries()]
      .sort((a, b) => b[0] - a[0])
      .map(([days, names]) => `${names.join(', ')}: ${days} gün`)
      .join(' · ');
  })();

  const faqs = [
    {
      q: 'Cafe Otomasyonu nedir? Hangi işletmeler için uygundur?',
      a: 'Cafe Otomasyonu; QR menü, QR sipariş, POS (kasa ve masa yönetimi), online sipariş ve paket servis, kurye takibi, sadakat puanı, cari-finans-ortaklık ve Yapay Zeka modüllerini tek panelden sunan bir dijital dönüşüm platformudur. Restoran, kafe, fast food, dürümcü, pastane/fırın, bistro, zincir işletme/market ve paket servis yapan tüm işletmelere uygundur.'
    },
    {
      q: 'Ücretsiz denemeler ve fiyatlandırma nasıl işliyor?',
      a: `QR Menü modülü daima ücretsizdir. Ücretsiz deneme süreleri — ${trialSentence}. Her modülün fiyatı ayrıdır ve yalnızca açtığınız modülü ödersiniz: ${priceSentence} (aylık, KDV ${vatIncluded ? 'dahil' : 'hariç'}). Yıllık ödemede 12 ay yerine 10 ay ücreti alınır.`
    },
    {
      q: 'QR Menü gerçekten sürekli ücretsiz mi?',
      a: 'Evet. QR Menü her zaman ücretsizdir. Sınırsız ürün/kategori, anlık düzenleme ve masa/alan bazlı QR oluşturma özellikleri ile dilediğiniz kadar kullanabilirsiniz.'
    },
    {
      q: 'Online siparişlerde komisyon alıyor musunuz?',
      a: 'Hayır. Online sipariş modülü komisyonsuz çalışır. Teslimat bölgeleri, servis saatleri, minimum sepet ve teslimat/gel-al gibi ayarlarınızı panelden yönetebilirsiniz.'
    },
    {
      q: 'POS için yazıcı zorunlu mu?',
      a: 'Zorunlu değildir ancak önerilir. Fiş yazıcısı kasa bilgisayarına kurulan masaüstü uygulamamız üzerinden yerel ağdaki cihaza doğrudan bağlanır; mutfak fişi istasyona göre ayrı ayrı basılır ve fiyat içermez. Yazıcı istemeyen işletmeler mutfak ekranını (KDS) kullanabilir.'
    },
    {
      q: 'İnternet kesilirse satış durur mu?',
      a: 'Hayır. POS çevrimdışı çalışacak şekilde tasarlandı: masa açma, ürün ekleme, mutfağa gönderme ve nakit ödeme internet olmadan da yapılabilir. Bağlantı geri geldiğinde işlemler sırasıyla senkronize olur ve tutarlar tutar. Yalnızca yetkili onayı gereken işlemler (gönderilmiş satırın iptali, ikram, iskonto) çevrimiçi olmayı gerektirir, çünkü PIN doğrulaması sunucuda yapılır.'
    },
    {
      q: 'QR Menü ile QR Menü Pro arasındaki fark ne?',
      a: `QR Menü ücretsizdir ve yalnızca görüntülemedir: misafir menüyü görür. QR Menü Pro ayrı bir modüldür: misafir yemeği telefonunda 3D görür ve "AR'da Gör" ile gerçek boyutunda masasına koyar, masadan sipariş verir, garson çağırır ve hesap ister. Sipariş varsayılan olarak garson onayı bekler, isterseniz doğrudan mutfağa gitmesini de ayarlayabilirsiniz. Masadan kartla ödeme yakında Pro'ya ekleniyor.`
    },
    {
      q: 'Stok ve maliyet takibi var mı?',
      a: 'Var. Ürünlerinize reçete tanımladığınızda, ürün mutfağa gönderildiği an hammadde stoktan düşer; maliyet ve kâr marjı kendiliğinden hesaplanır. Fire oranı reçetenin parçasıdır. Stok sayımı yapıp teorik-fiili fark raporuyla kaybın nerede olduğunu görebilirsiniz. Menü Mühendisliği ekranı da ürünlerinizi katkı payı ve popülerliğe göre dört gruba ayırıp ne yapmanız gerektiğini söyler.'
    },
    {
      q: 'Şubeler için farklı fiyat uygulayabilir miyim?',
      a: 'Evet. Menü merkezden yönetilir; kanal (salon, paket, online), şube ve saat aralığı bazında fiyat listesi tanımlayabilirsiniz — happy hour dahil, gece yarısını aşan aralıklar destekleniyor. Şubeler merkezden gelen ürünü kapatabilir ancak kendi başına ürün açamaz, böylece merkezî fiyat değişikliği her şubeye ulaşır. Satış ve operasyon raporları şubeye göre süzülebilir.'
    },
    {
      q: 'Ortaklı işletmeyim, kâr paylaşımını sistem hesaplıyor mu?',
      a: 'Evet. Cari & Finans modülü çift taraflı muhasebe defteri mantığıyla çalışır. Üç katılım biçimi destekleniyor: kâr ve gideri paylaşan tam ortak, kârdan pay alıp zarara katılmayan sessiz ortak ve ciro üzerinden pay alan işletmeci. Sermaye iadesi kâr dağıtımından önce yapılır, dönem kapanışı ile hesap kilitlenir, kayıtlar silinmez — düzeltme ters kayıtla yapılır.'
    },
    {
      q: 'Yemeksepeti, Trendyol Go ve Getir entegrasyonu var mı?',
      a: 'Henüz satışa açmadık. Pazaryeri entegrasyonu için platform anlaşmalarının tamamlanması gerekiyor; gerçek API bağlantısı kurulmadan bu modülü satmak istemiyoruz. Anlaşmalar tamamlandığında duyuracağız.'
    },
    {
      q: 'Kurye mobil uygulaması neler sağlar? Zorunlu mu?',
      a: 'Kurye uygulaması canlı konum paylaşımı, online/offline durum, siparişe göre haritaya odaklanma ve navigasyon ile teslimat geçmişi sağlar. Paket teslimatı yapan işletmeler için önerilir, zorunlu değildir.'
    },
    {
      q: 'Çoklu şube yönetimi var mı?',
      a: 'Evet. Tek panelden birden fazla şubeyi yönetir, menüyü merkezden yayınlar, şube bazlı fiyat ve ürün istisnaları tanımlarsınız. Raporlarda şube seçici vardır ve Cari & Finans modülüyle şube bazlı kâr-zarar karşılaştırması yapabilirsiniz. Stok kartları şu an firma seviyesindedir; şube bazlı stok yol haritasındadır.'
    },
    {
      q: 'Veri güvenliği ve KVKK uyumluluğu nasıl sağlanıyor?',
      a: 'Sistem SSL ile korunur, oturum anahtarları kısa ömürlüdür (15 dakika) ve iptal edilebilir. Şifrenizi değiştirdiğinizde o hesabın tüm oturumları düşer; açık oturumları listeleyip tek tek kapatabilirsiniz. Personel yetkileri rol bazlıdır ve kişi bazında daraltılabilir; iptal, ikram ve iskonto gibi işlemler için yetkili PIN onayı zorunlu kılınabilir. KVKK/Gizlilik/Çerez politikaları uygulanır.'
    },
    {
      q: 'Destek kanalları nelerdir?',
      a: 'E-posta: info@cafeotomasyonu.com ve WhatsApp: https://wa.me/905075880481 üzerinden destek veriyoruz. Ayrıca panelden talep oluşturabilirsiniz.'
    },
    {
      q: 'Nasıl başlayabilirim? Kurulum ne kadar sürer?',
      a: 'Ücretsiz kayıt olarak 10 dakika içinde canlıya geçebilirsiniz. Kayıt: https://panel.cafeotomasyonu.com/sign-up adresinden yapılabilir.'
    }
  ];

  useEffect(() => {
    // FAQ structured data (FAQPage)
    const faqStructured = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.a
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(faqStructured);
    document.head.appendChild(script);

    return () => {
      const existing = document.querySelectorAll('script[type="application/ld+json"]');
      // Remove only the last appended FAQ script for safety
      if (existing && existing.length > 0) {
        const last = existing[existing.length - 1];
        if (last && last.textContent && last.textContent.includes('"FAQPage"')) {
          document.head.removeChild(last);
        }
      }
    };
  }, [priceSentence, trialSentence]);

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            Sıkça Sorulan Sorular (SSS)
          </h2>
          <p className="font-open-sans font-body-normal text-lg text-text-secondary max-w-3xl mx-auto">
            Cafe Otomasyonu hakkında merak ettikleriniz. Fiyatlandırma, kurulum, entegrasyon ve güvenlik gibi başlıklarda en çok sorulan soruları derledik.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {faqs.map((item, idx) => (
            <details key={idx} className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
              <summary className="flex items-center justify-between cursor-pointer">
                <h3 className="font-poppins font-heading-semibold text-lg text-foreground pr-4">
                  {item.q}
                </h3>
                <span className="ml-2 w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center transition-transform group-open:rotate-45">
                  +
                </span>
              </summary>
              <div className="mt-4 font-open-sans font-body-normal text-text-secondary leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://panel.cafeotomasyonu.com/sign-up"
            className="inline-flex items-center px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold hover:opacity-90 transition"
            rel="nofollow noopener"
          >
            Ücretsiz Kayıt Ol ve Hemen Başla
          </a>
          <div className="mt-4">
            <a
              href="/assets/docs/CafeOtomasyonu-Tanitim-ve-Kullanim.pdf"
              className="inline-flex items-center px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold hover:bg-primary/5 transition"
            >
              Kullanım Dökümantasyonu (PDF)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;


